import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 18h-7a3 3 0 0 1 -3 -3v-10","key":"svg-0"}]]

const IconCurrencyLeu = createReactComponent('outline', 'currency-leu', 'CurrencyLeu', __iconNode);

export default IconCurrencyLeu;